module.exports = __webpack_public_path__ + "static/media/33.2cee00fb.png";